import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import Icon from '../components/Icon';

export default function Nutrition() {
  const navigate = useNavigate();
  const [plans,   setPlans]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/nutrition').then(setPlans).finally(() => setLoading(false));
  }, []);

  async function handleDelete(e, id) {
    e.stopPropagation();
    if (!window.confirm('Delete this nutrition plan?')) return;
    await api.delete('/nutrition/' + id);
    setPlans(prev => prev.filter(p => p.id !== id));
  }

  async function handleDuplicate(e, id) {
    e.stopPropagation();
    try {
      const copy = await api.post('/nutrition/' + id + '/duplicate');
      setPlans(prev => [copy, ...prev]);
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1>
          <Icon name="icon-nutrition.png" />
          Nutrition Plans
        </h1>
        <button className="icon-btn" onClick={() => navigate('/nutrition/new')}>
          <Icon name="icon-add.png" alt="Add" />
        </button>
      </div>

      <div className="page-content">
        {loading ? (
          <div className="loading-spinner"><span className="spinner" /></div>
        ) : plans.length === 0 ? (
          <div className="empty-state">
            <Icon name="icon-nutrition.png" size={48} style={{ opacity: 0.3 }} />
            <p>No nutrition plans yet</p>
            <button className="btn btn-primary" style={{ width: 'auto', padding: '0 24px' }} onClick={() => navigate('/nutrition/new')}>
              Create First Plan
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {plans.map(p => (
              <div key={p.id} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate('/nutrition/' + p.id)}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{p.name}</div>
                    {p.goal && <div style={{ fontSize: 13, color: 'var(--color-text-muted)', marginTop: 4 }}>{p.goal}</div>}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
                      {p.daily_calories  && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>{p.daily_calories} kcal</span>}
                      {p.daily_protein_g && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>P: {p.daily_protein_g}g</span>}
                      {p.daily_carbs_g   && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>C: {p.daily_carbs_g}g</span>}
                      {p.daily_fat_g     && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>F: {p.daily_fat_g}g</span>}
                      {p.duration_weeks  && <span style={{ fontSize: 12, color: 'var(--color-text-muted)' }}>{p.duration_weeks} weeks</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="icon-btn" title="Duplicate" onClick={e => handleDuplicate(e, p.id)}>
                      <Icon name="icon-duplicate.png" alt="Duplicate" />
                    </button>
                    <button className="icon-btn" onClick={e => handleDelete(e, p.id)}>
                      <Icon name="icon-delete.png" alt="Delete" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
